module.exports = __webpack_public_path__ + "static/media/Ganyu.1ae0d0aa.png";